import React, { Component } from "react";
import { CommonTabs } from "../TabBarCompoenent/CommonTabs";
import { versionInfo } from "../MainPage/VersionInfo";
import { languageService } from "../../Language/language.service";
import AssetNomenclatureListContainer from "../AssetNomenclatureList";
import EquipmentCompletionStatus from "./EquipmentcompletionStatus";
import { Redirect, Route, Switch, withRouter } from "react-router-dom";

class SupportPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTab: "",
      tabs: [],
    };
  }

  componentDidMount() {
    const Tlist = [
      { id: "nomenclature", label: languageService("Nomenclature"), path: "/support/nomenclature" },
      { id: "equipmentCompletion", label: languageService("Equipment Status"), path: "/support/equipmentCompletion" },
    ];

    const application = versionInfo.getApplicationType();

    if (application !== "TIMPS") {
      let selectedTab = Tlist.find((tab) => tab.path === this.props.location.pathname) || Tlist[0];
      this.setState({
        tabs: Tlist,
        selectedTab: selectedTab.id,
      });
    }
  }

  render() {
    const { tabs, selectedTab } = this.state;
    const { history } = this.props;

    return (
      <div style={{ width: "100%", padding: "15px" }}>
        <div>
          {tabs.length > 0 && (
            <CommonTabs
              tabs={tabs}
              onTabChange={(tab) => {
                this.setState({ selectedTab: tab.id });
                history.push(tab.path); // Navigate to the route
              }}
              selectedTab={selectedTab} // Match active tab by pathname
            />
          )}
        </div>
        <div style={{ marginBlockStart: "10px" }}>
          <Switch>
            <Route path="/support/nomenclature" component={AssetNomenclatureListContainer} />
            <Route path="/support/equipmentCompletion" component={EquipmentCompletionStatus} />
            {/* Redirect default to first tab */}
            <Redirect exact from="/support" to="/support/nomenclature" />
          </Switch>
        </div>
      </div>
    );
  }
}

export default withRouter(SupportPage);



// WEBPACK FOOTER //
// ./src/components/SupportPage/Index.jsx